import React from 'react';
import { useTranslation } from 'react-i18next';
import HardwareSignupCard from '../../../HardwareSignupCard/HardwareSignupCard';
import { useState } from 'react';
import HardwareInclusiveModal from '../../HardwareInclusiveModal/HardwareInclusiveModal';
import HardwareInclusiveModalCard from '../../HardwareInclusiveModal/HardwareInclusiveModalCard/HardwareInclusiveModalCard';
import { DEVICE_USAGE_TYPE } from '../../../../../../constants/AppConstants';

const DisplayDeviceType = (props) => {
    const { handleSelectionChange, selectedData, hardwareFeatureFlags } = props
    const showRefurbished = hardwareFeatureFlags.isHWOnly || hardwareFeatureFlags.isBothEnabled;
    const showNew = hardwareFeatureFlags.isNPBOnly || hardwareFeatureFlags.isBothEnabled;
    const { t } = useTranslation(["translation"])

    const [modalState, setModalState] = useState(false);
    const toggleModal = () => {
        setModalState(!modalState);
    }
    const onModalSelect = (value) => {
        handleSelectionChange(value)
        setModalState(false)
    }

    return (
        <>
            <div className='cp-subtitle'>{t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.CHOOSE_DEVICE_TYPE")}</div>
            <div className='cp-card'>
                {showNew &&
                    <HardwareSignupCard
                        onHardwarePlanSelection={handleSelectionChange}
                        selectedCard={selectedData}
                        toCompareSelectedCardWith={DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE}
                        cardRightData={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.NEW")}
                        displayMoreInfo={() => toggleModal()}
                        cardInfo={hardwareFeatureFlags?.isBothEnabled}
                    ></HardwareSignupCard>
                }
                {showRefurbished &&
                    <HardwareSignupCard
                        onHardwarePlanSelection={handleSelectionChange}
                        selectedCard={selectedData}
                        toCompareSelectedCardWith={DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE}
                        cardRightData={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.REFURBISHED")}
                        displayMoreInfo={() => toggleModal()}
                        cardInfo={hardwareFeatureFlags?.isBothEnabled}
                    ></HardwareSignupCard>
                }
            </div>
            <HardwareInclusiveModal
                modalState={modalState}
                toggleModal={toggleModal}
                modalHeader={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.CHOOSE_DEVICE_TYPE")}
            >
                <HardwareInclusiveModalCard
                    title={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.NEW")}
                    info={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.NEW_DEVICE_DESCRIPTION")}
                    value={DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE}
                    onModalSelect={onModalSelect}
                ></HardwareInclusiveModalCard>
                <HardwareInclusiveModalCard
                    title={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.REFURBISHED")}
                    info={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.DEVICE_TYPE.REFURBISHED_DEVICE_DESCRIPTION")}
                    value={DEVICE_USAGE_TYPE.HARDWARE_INCLUSIVE}
                    onModalSelect={onModalSelect}
                ></HardwareInclusiveModalCard>
            </HardwareInclusiveModal>
        </>
    );
};

export default DisplayDeviceType;